import { render, staticRenderFns } from "./FrameTool.vue?vue&type=template&id=275a1d82&scoped=true&lang=pug"
import script from "./FrameTool.vue?vue&type=script&lang=ts"
export * from "./FrameTool.vue?vue&type=script&lang=ts"
import style0 from "./FrameTool.vue?vue&type=style&index=0&id=275a1d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a1d82",
  null
  
)

/* custom blocks */
import block0 from "./FrameTool.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports